import { render, staticRenderFns } from "./button-loader.vue?vue&type=template&id=87395708&scoped=true&"
import script from "./button-loader.vue?vue&type=script&lang=js&"
export * from "./button-loader.vue?vue&type=script&lang=js&"
import style0 from "./button-loader.vue?vue&type=style&index=0&id=87395708&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87395708",
  null
  
)

export default component.exports